import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Priority: 1) window.FIREBASE_CONFIG (from config.js), 2) env vars, 3) fallbacks
const windowConfig = typeof window !== 'undefined' && window.FIREBASE_CONFIG ? window.FIREBASE_CONFIG : {};

const firebaseConfig = {
  apiKey: windowConfig.apiKey || import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCk5EgFvDszM5SxPgm6SSqgxPuwiNKT8xc',
  authDomain: windowConfig.authDomain || import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'fournitures-c28ae.firebaseapp.com',
  projectId: windowConfig.projectId || import.meta.env.VITE_FIREBASE_PROJECT_ID || 'fournitures-c28ae',
  storageBucket: windowConfig.storageBucket || import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'fournitures-c28ae.firebasestorage.app',
  messagingSenderId: windowConfig.messagingSenderId || import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '621587726722',
  appId: windowConfig.appId || import.meta.env.VITE_FIREBASE_APP_ID || '1:621587726722:web:54143173878be147c34f9b'
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
